module.exports = __webpack_public_path__ + "static/media/0081_Small.506069cb.jpg";